/**
 * TODAY'S 404 — what prest0.ai shows at an address the app has no page for (src/App.tsx's catch-all route, `*`).
 *
 * Moved out of App.tsx unchanged on 2026-10-11 (PV5-8:A): the same markup and inline styles, rendered byte for byte as
 * before. Its words are src/components/notFound/notFoundWords.ts, the one copy the new design's 404 reads too
 * (src/design/pavilion/pages/not-found/), which App.tsx shows in its place in the demonstration tree.
 *
 * ITS HEAD is the one change the rebuild made on prest0.ai: a tab title and noindex (it had no head of its own, so the
 * tab read the site's default title and an address with no page was open to search). Both pages write the same head
 * from the words module; the parity test reads the two equal.
 */
import React from 'react';
import SeoHead from '../components/SeoHead';
import { NOT_FOUND_WORDS as W } from '../components/notFound/notFoundWords';

// Simple 404 Not Found component
const NotFound: React.FC = () => {
  return (
    <>
      <SeoHead {...W.seo} noIndex />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4rem 2rem',
        textAlign: 'center',
        minHeight: 'calc(100vh - 160px)'
      }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '1rem', color: '#333' }}>{W.title}</h1>
        <p style={{ fontSize: '1.25rem', color: '#666', marginBottom: '2rem' }}>
          {W.line}
        </p>
        <a
          href="/"
          style={{
            padding: '0.75rem 1.5rem',
            background: '#4A90E2',
            color: 'white',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: 500,
            textTransform: 'lowercase'
          }}
        >
          {W.home}
        </a>
      </div>
    </>
  );
};

export default NotFound;
